<app-header [workType]="workType"></app-header>
<app-breadcrumbs></app-breadcrumbs>
<app-flash-message></app-flash-message>
<router-outlet></router-outlet>
<app-footer [workType]="workType"></app-footer>
